export default __webpack_public_path__ + "static/media/Olim9.49f6a764.png";